import Vuetify from '@/plugins/vuetify';

Vuetify.framework.lang.current = (localStorage.getItem('idioma')) ? localStorage.getItem('idioma') : 'pt';

export default {
  fretes: [],
  totalNumFretes: 0,
  totalNF: 0,
  pesoTotal: 0,
  totalFretes: 0,
  mediaKG: 0,
  dentroPrazo: 0,
  foraPrazo: 0,
  totalFechados: 0,
  totalPendentes: 0,
  analiseHeaders: [],
  colunasFretes: [
    {
      value: 'origem',
      i18n: 'origem',
      text: '',
      sortable: true,
      filterable: true,
      filterComponent: 'TextFilter',
      width: '200px',
    },
    {
      value: 'destino',
      i18n: 'destino',
      text: '',
      sortable: true,
      filterable: true,
      filterComponent: 'TextFilter',
      width: '200px',
    },
    {
      value: 'data',
      i18n: 'data',
      text: '',
      sortable: true,
      filterable: true,
      filterComponent: 'DateFilter',
      width: '100px',
    },
    {
      value: 'doc',
      i18n: 'doc',
      text: '',
      sortable: true,
      filterable: true,
      filterComponent: 'TextFilter',
      width: '100px',
    },
    {
      value: 'minuta',
      i18n: 'minuta',
      text: '',
      sortable: true,
      filterable: true,
      filterComponent: 'TextFilter',
      width: '120px',
    },
    {
      value: 'tipo',
      i18n: 'tipo',
      text: '',
      sortable: true,
      filterable: true,
      filterComponent: 'TextFilter',
      width: '120px',
    },
    {
      value: 'emissaoCTe',
      i18n: 'emissaoCTe',
      text: '',
      sortable: true,
      filterable: true,
      filterComponent: 'DateFilter',
      width: '150px',
    },
    {
      value: 'nf',
      i18n: 'nf',
      text: '',
      sortable: true,
      filterable: true,
      filterComponent: 'TextFilter',
      width: '150px',
    },
    {
      value: 'qtdeNF',
      i18n: 'qtdeNF',
      text: '',
      sortable: true,
      filterable: true,
      filterComponent: 'TextFilter',
      width: '180px',
    },
    {
      value: 'volumes',
      i18n: 'volumes',
      text: '',
      sortable: true,
      filterable: true,
      filterComponent: 'TextFilter',
      width: '140px',
    },
    {
      value: 'pesoTaxado',
      i18n: 'pesoTaxado',
      text: '',
      sortable: true,
      filterable: true,
      filterComponent: 'TextFilter',
      width: '150px',
    },
    {
      value: 'valorNF',
      i18n: 'valorNF',
      text: '',
      sortable: true,
      filterable: true,
      filterComponent: 'TextFilter',
      width: '140px',
    },
    {
      value: 'valorFrete',
      i18n: 'valorFrete',
      text: '',
      sortable: true,
      filterable: true,
      filterComponent: 'TextFilter',
      width: '140px',
    },
    {
      value: 'valorKG',
      i18n: 'valorKG',
      text: '',
      sortable: true,
      filterable: true,
      filterComponent: 'TextFilter',
      width: '140px',
    },
    {
      value: 'freteNF',
      i18n: 'freteNF',
      text: '',
      sortable: true,
      filterable: true,
      filterComponent: 'TextFilter',
      width: '220px',
    },
    {
      value: 'previsao',
      i18n: 'previsao',
      text: '',
      sortable: true,
      filterable: true,
      filterComponent: 'DateFilter',
      width: '150px',
    },
    {
      value: 'finalizado',
      i18n: 'finalizacao',
      text: '',
      sortable: true,
      filterable: true,
      filterComponent: 'DateFilter',
      width: '150px',
    },
    {
      value: 'performance',
      i18n: 'performance',
      text: '',
      sortable: true,
      filterable: true,
      filterComponent: 'TextFilter',
      width: '160px',
    },
    {
      value: 'statusEntrega',
      i18n: 'statusEntrega',
      text: '',
      sortable: true,
      filterable: true,
      filterComponent: 'TextFilter',
      width: '200px',
    },
  ],
  filtros: {
    page: 1,
    performance: false,
    itemsPerPage: 10,
    sortBy: [],
    sortDesc: [false],
    groupBy: [],
    groupDesc: [],
    mustSort: false,
    multiSort: false,
  },
  campos: {
    origem: 'origem',
    destino: 'destino',
    data: 'data',
    doc: 'doc',
    minuta: 'minuta',
    tipo: 'tipo',
    emissaoCTe: 'emissaoCTe',
    nf: 'nf',
    qtdeNF: 'qtdeNF',
    volumes: 'volumes',
    pesoTaxado: 'pesoTaxado',
    valorNF: 'valorNF',
    valorFrete: 'valorFrete',
    valorKG: 'valorKG',
    freteNF: 'freteNF',
  },
};
